import {
  Row,
  Select,
  Typography,
  Input,
  Button,
  Col,
  Form,
  InputNumber,
  Collapse,
  DatePicker,
  notification,
  Modal,
  Space,
} from "antd";
import moment from "moment";
import React, { useEffect, useState, useCallback } from "react";
import { DOUBLE_REGEX, NUMBER_REGEX } from "shared/constants/AppConstants";
import { numberWithCommas } from "shared/services/Utility";
import shareIcon from "../../../../assets/images/shareIcon.svg";
import copy from "../../../../assets/images/copy.svg";
import "./index.scss";
import DocumentStatus from "../RequiredDocuments/DocumentStatus";
import { useSelector } from "react-redux";
import { RootState } from "shared/redux/store";

const { Panel } = Collapse;
const { TextArea } = Input;
const { Text } = Typography;

const DisbursedGroup: React.FunctionComponent<any> = ({
  lender,
  lenderIndex,
  payment,
  index,
  payoutDetailIndex,
  onAmountChange,
  onActionSubmit,
  leadData,
  setIsAddDisabled,
  setAddBtnErr,
  getRedirectURLLink,
  loadingUpdate,
  getDownloadLetterForICICI,
}) => {
  const [disbursedForm] = Form.useForm() as any;
  const dateFormat = "YYYY-MM-DD";
  const [showConfirmationPayout, setShowConfirmationPayout] = useState(false);
  const [finalValue, setFinalValue] = useState(null as any);
  const [loading, setLoading] = useState(false);

  const payoutType = leadData?.caseDetails?.connectorDetails?.payoutType;
  const checkTenativePayout =
    leadData?.caseDetails?.connectorDetails?.payoutPercentage;

  const [showDocumentStatus, setShowDocumentStatus] = useState(false);
  const [documentDetails, setDocumentDetails] = useState(null);
  const [selectedLender, setSelectedLender] = useState({} as any);
  const { appColors }: any = useSelector((state: RootState) => state.common);
  //TODO: ICICI demo report Download
  const base64 =
    "data:application/pdf;base64,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";

  useEffect(() => {
    if (!loadingUpdate) {
      setLoading(false);
    }
    const setData = {} as any;
    const disbursalData = {
      disbursedAmount: payment?.lenderAmount?.disbursedAmount,
      insuranceAmount: payment?.lenderAmount?.insuranceAmount
    }
    setData[`${lenderIndex}-${index}`] = disbursalData
    disbursedForm.setFieldsValue({...setData})
  }, [loadingUpdate]);

  const finalSubmit = (value: any) => {
    const infoEntity = lender?.disbursalLenderInfoDetails?.find(
      (item: any) => item?.disbursalId == payment?.disbursalId
    );

    const tmpLender = { ...lender };
    tmpLender.disbursalLenderInfoDetails = null;
    tmpLender.disbursalLenderInfoEntity = [infoEntity];
    if (value?.payoutPercentage == 0) {
      notification.error({
        message:
          "Please ensure that payout % are filled, this field will not be editable beyond this point.",
      });
    } else {
      setLoading(true);
      onActionSubmit(tmpLender, value?.comment);
    }
  };

  const confirmationSubmit = () => {
    finalSubmit(finalValue);
    setShowConfirmationPayout(false);
  };

  const actionSubmit = (value: any) => {
    if (
      payoutType == "FIXED" &&
      value?.payoutPercentage !== checkTenativePayout
    ) {
      setFinalValue(value);
      setShowConfirmationPayout(true);
    } else {
      finalSubmit(value);
    }
  };

  const handleCancel = () => {
    setShowConfirmationPayout(false);
    disbursedForm.setFieldsValue({
      payoutPercentage: checkTenativePayout,
    });
  };

  const disbursedInputHandler = (value, lenderIndex, name, i) => {
    lender.disbursalLenderInfoDetails[i].lenderAmount[name] = value;
    onAmountChange();
  };

  const DatePickerInputHandler = (value, lenderIndex, name, i) => {
    lender.disbursalLenderInfoDetails[i].lenderAmount[name] = value
      ? moment(value).format("YYYY-MM-DD").toString()
      : "";
  };

  const payoutPercentageInputHandler = (value, name, i) => {
    lender.disbursalLenderInfoDetails[i].lenderAmount[name] = value;
  };
  const renderDocumentStatus = (lender) => {
    const total = lender?.documentProgressDetails?.totalNumberOfDocs ?? 0;
    const submitted =
      lender?.documentProgressDetails?.documentsSuccessfullySubmitted ?? 0;
    const failed = lender?.documentProgressDetails?.failure ?? 0;
    return (
      <>
        {total > 0 && (submitted > 0 || failed > 0) && (
          <span
            style={{ cursor: "pointer", fontSize: "11px", float: "right" }}
            onClick={() => {
              setDocumentDetails(
                lender?.documentProgressDetails?.submissionDetails
              );
              setSelectedLender(lender);
              setShowDocumentStatus(true);
            }}
          >
            {`Document Status: ${submitted}/${total}`}
          </span>
        )}
      </>
    );
  };

  const btnPrimaryStyles: any = { '--btnColor': appColors?.appPrimaryColor ?? "" };

  const getHeader = () => {
    setIsAddDisabled(!payment?.disbursalId);
    setAddBtnErr('Please fill current disbursement details before adding a disbursement');
  return  (
    <>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        {`${lender.lenderName} - Disbursal #${payoutDetailIndex + 1}`}
      </div>
      <div style={{ display: "grid" }}>
        {payment?.disbursalId?.length > 0 ? (
          <span style={{ fontSize: "11px" }}>
            Disbursal ID: {payment?.disbursalId}&nbsp;
            <Button
              style={{
                border: "none",
                cursor: "copy",
                height: "20px",
                padding: "0px",
                paddingLeft: "5px",
              }}
              onClick={() => {
                navigator.clipboard.writeText(payment?.disbursalId);
              }}
            >
              <img src={copy} alt="" width={11} />
            </Button>
          </span>
        ) : (
          ""
        )}

        {!lender?.lenderName?.toLowerCase()?.includes("bajaj housing finance") && lender?.submissionType?.includes("API") &&
          (lender?.lenderApplicationId?.length ?? 0) > 0 && (
            <span style={{ fontSize: "11px", float: "left" }}>
              {`Lender loan ID: ${lender.lenderApplicationId}`}
            </span>
          )}

        {/* BAJAJ HOSUING FINANCE Changes */}

        {lender?.lenderName?.toLowerCase()?.includes("bajaj housing finance") && (
          <div className="checkbox-text-div">
            {lender?.submissionType?.includes("API") &&
              lender?.additionalFields?.length > 0 &&
              lender?.lenderName?.toLowerCase()?.includes("bajaj housing finance") && (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="checkbox-text small">{`Lender lead ID: ${JSON.parse(lender?.additionalFields)?.leadId}`}</span>
                  <Button
                    style={{
                      borderColor: "transparent",
                      fontSize: "12px",
                    }}
                    size="small"
                    shape="circle"
                    onClick={() => {
                      navigator.clipboard.writeText(
                        JSON.parse(lender?.additionalFields)?.leadId ??
                        ""
                      );
                      notification.success({
                        message: "Copied to clipboard",
                      });
                    }}
                    icon={<img src={copy} alt="" width={12} />}
                  />
                </div>
              )}
          </div>

        )}

        {lender?.lenderName?.toLowerCase()?.includes("bajaj housing finance") && (
          <div className="checkbox-text-div">
            {lender?.submissionType?.includes("API") &&
              lender?.additionalFields?.length > 0 &&
              lender?.lenderName?.toLowerCase()?.includes("bajaj housing finance") && (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="checkbox-text small">{`Lender Offer ID: ${JSON.parse(lender?.additionalFields)?.offerId}`}</span>
                  <Button
                    style={{
                      borderColor: "transparent",
                      fontSize: "12px",
                    }}
                    size="small"
                    shape="circle"
                    onClick={() => {
                      navigator.clipboard.writeText(
                        JSON.parse(lender?.additionalFields)?.offerId ??
                        ""
                      );
                      notification.success({
                        message: "Copied to clipboard",
                      });
                    }}
                    icon={<img src={copy} alt="" width={12} />}
                  />
                </div>
              )}
          </div>

        )}


        {lender?.submissionType?.includes("API") &&
          lender?.additionalFields?.length > 0 &&
          lender?.lenderName?.toLowerCase()?.includes("icici") && (
            <div
              style={{
                display: "flex",
                fontSize: "11px",
                alignItems: "center",
              }}
            >
              <span style={{ fontSize: "11px" }}>{`iLens ID: ${JSON.parse(lender?.additionalFields)?.ilensId
                }`}</span>
              <Button
                style={{ borderColor: "transparent", fontSize: "11px" }}
                size="small"
                shape="circle"
                className="small"
                // style={{ fontSize: "12px" }}
                onClick={() => {
                  navigator.clipboard.writeText(
                    JSON.parse(lender?.additionalFields)?.ilensId ?? ""
                  );
                  notification.success({ message: "Copied to clipboard" });
                }}
                icon={<img src={copy} alt="" width={10} />}
              />
            </div>
          )}
        {lender?.submissionType?.includes("API") &&
          lender?.additionalFields?.length > 0 &&
          lender?.lenderName?.toLowerCase()?.includes("icici") && (
            <div
              style={{
                display: "flex",
                fontSize: "11px",
                alignItems: "center",
              }}
            >
              <span style={{ fontSize: "11px" }}>{`Application Form No: ${JSON.parse(lender?.additionalFields)?.applicationFormNo
                }`}</span>
              <Button
                style={{ borderColor: "transparent", fontSize: "11px" }}
                size="small"
                shape="circle"
                className="small"
                // style={{ fontSize: "12px" }}
                onClick={() => {
                  navigator.clipboard.writeText(
                    JSON.parse(lender?.additionalFields)?.applicationFormNo ??
                    ""
                  );
                  notification.success({ message: "Copied to clipboard" });
                }}
                icon={<img src={copy} alt="" width={10} />}
              />
            </div>
          )}
        {renderDocumentStatus(lender)}
      </div>
      {lender?.submissionType?.includes("API") &&
        (lender?.lenderApplicationId?.length ?? 0) > 0 && (
          <span className="flex" style={{ display: "flex" }}>
            {(["BU9709497975", "BU3620294738"].includes(lender.lenderInfoId) ||
              lender?.lenderName?.toLowerCase()?.includes("fibe") ||
              lender?.lenderName?.toLowerCase()?.includes("moneywide") ||
              lender?.lenderName?.toLowerCase()?.includes("cashe") ||
              lender?.lenderName?.toLowerCase()?.includes("kreditbee") ||
              lender?.lenderName?.toLowerCase()?.includes("abcfl") ||
              lender?.lenderName?.toLowerCase()?.includes("abcl") ||
              lender?.lenderName?.toLowerCase()?.includes("prefr") ||
              lender?.lenderName?.toLowerCase()?.includes("incred") ||
              lender?.lenderName?.toLowerCase()?.includes("credilio")) && (
                <>
                  <a
                    onClick={() =>
                      getRedirectURLLink(
                        lender?.lenderInfoId,
                        leadData?.loanProductId,
                        lender?.lenderApplicationId
                      )
                    }
                    className="small"
                    style={{ fontSize: "12px", marginBlock: "auto" }}
                  >
                    {lender?.lenderName?.toLowerCase()?.includes("abcfl") ||
                      lender?.lenderName?.toLowerCase()?.includes("abcl")
                      ? "ABCL Dashboard"
                      : `${lender.lenderName.split(" ")[0]} Dashboard`}
                  </a>
                  <Button
                    size="small"
                    style={{ margin: "2px", border: "none" }}
                    onClick={() =>
                      getRedirectURLLink(
                        lender?.lenderInfoId,
                        leadData?.loanProductId,
                        lender?.lenderApplicationId,
                        true
                      )
                    }
                    icon={
                      <img
                        src={shareIcon}
                        alt=""
                        width={18}
                        height={18}
                        style={{ marginTop: "-4px" }}
                      />
                    }
                  />
                </>
              )}
          </span>
        )}
      {lender?.submissionType?.includes("API") &&
        (lender?.lenderApplicationId?.length ?? 0) > 0 && (
          <span className="flex" style={{ display: "flex" }}>
            {["BU9709497975", "BU3620294738"].includes(lender.lenderInfoId) ||
              (lender?.lenderName?.toLowerCase()?.includes("icici") && (
                <>
                  <a
                    className="small"
                    style={{ fontSize: "12px" }}
                    onClick={() => {
                      getDownloadLetterForICICI(lender?.lenderInfoId);
                    }}
                  >
                    {lender.lenderName.split(" ")[0]} Download letter
                  </a>
                </>
              ))}
          </span>
        )}
    </>
  )};

  const keyCol = `${lenderIndex}-${payoutDetailIndex}`;
  return (
    <div key={payoutDetailIndex} style={{ marginBottom: "8px" }}>
      {showDocumentStatus && (
        <DocumentStatus
          showDocumentStatus={showDocumentStatus}
          setShowDocumentStatus={setShowDocumentStatus}
          lenderInfoId={selectedLender?.lenderInfoId}
          caseId={leadData?.caseDetails?.caseId}
          documentDetails={documentDetails}
        />
      )}
      <Form form={disbursedForm} onFinish={actionSubmit}>
        <Collapse
          className="payout-collapse"
          collapsible="header"
          expandIconPosition="end"
        >
          <Panel header={getHeader()} key={keyCol}>
            <div className="bg-title">
              <Text>Disbursal Details</Text>
            </div>
            <div style={{ paddingInline: "16px" }}>
              <Row
                className="disbursed-lenders-header"
                style={{ paddingTop: "10px" }}
              >
                <Col span={12} className="disbursed-heading">
                  Insurance Amount
                </Col>
                <Col span={12} className="disbursed-heading">
                  Disbursed Amount
                </Col>
              </Row>
              <Form.List name={`${lenderIndex}-${index}`}>
                {(fields) => (
                  <Row className="selected-lender-row" gutter={[6, 6]}>
                    <Col span={12} className="disbursed-row">
                      <Form.Item
                        name="insuranceAmount"
                        // initialValue={payment?.lenderAmount?.insuranceAmount}
                        rules={[
                          {
                            required: true,
                            message: "Please enter amount",
                          },
                          () => ({
                            validator(_, value) {
                              // let amountDisbursed =
                              //   lender.disbursalLenderInfoDetails.map((item) =>
                              //     Number(item.lenderAmount.disbursedAmount)
                              //   );
                              // let amountInsurance =
                              //   lender.disbursalLenderInfoDetails.map((item) =>
                              //     Number(item.lenderAmount.insuranceAmount)
                              //   );
                              // const totalDisbursed = amountDisbursed.reduce(
                              //   (a, b) => a + b,
                              //   0
                              // );
                              // const totalInsurance = amountInsurance.reduce(
                              //   (a, b) => a + b,
                              //   0
                              // );
                              // const total = totalDisbursed + totalInsurance;

                              if (!value && value != 0) {
                                return Promise.reject();
                              }
                              if (isNaN(value)) {
                                return Promise.reject(
                                  "Please enter valid amount"
                                );
                              }
                              // const availbleAmount =
                              //   lender.sanctionedAmount - (total - value);
                              // if (value > availbleAmount) {
                              //   return Promise.reject(
                              //     `Please enter less amount than ${availbleAmount}`
                              //   );
                              // }
                              return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        <InputNumber
                          onChange={(ev) =>
                            disbursedInputHandler(
                              ev,
                              lenderIndex,
                              "insuranceAmount",
                              index
                            )
                          }
                          disabled={payment?.lenderAmount?.isDisabled ?? false}
                          className="custom-input-number"
                          // defaultValue={payment?.lenderAmount?.insuranceAmount}
                          formatter={(value) => numberWithCommas(value)}
                          parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
                          name="insuranceAmount"
                          placeholder="Amount"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12} className="disbursed-row">
                      <Form.Item
                        name="disbursedAmount"
                        // initialValue={payment?.lenderAmount?.disbursedAmount}
                        rules={[
                          {
                            required: true,
                            message: "Please enter amount",
                          },
                          {
                            pattern: NUMBER_REGEX,
                            message: "Please enter valid amount",
                          },
                          () => ({
                            validator(_, value) {
                              let amountDisbursed =
                                lender.disbursalLenderInfoDetails.map((item) =>
                                  Number(item.lenderAmount.disbursedAmount)
                                );
                              // let amountInsurance =
                              //   lender.disbursalLenderInfoDetails.map((item) =>
                              //     Number(item.lenderAmount.insuranceAmount)
                              //   );
                              const totalDisbursed = amountDisbursed.reduce(
                                (a, b) => a + b,
                                0
                              );
                              // const totalInsurance = amountInsurance.reduce(
                              //   (a, b) => a + b,
                              //   0
                              // );
                              const total = totalDisbursed;

                              if (value == 0) {
                                return Promise.reject(
                                  "Please enter valid amount"
                                );
                              }
                              if (isNaN(value)) {
                                return Promise.reject(
                                  "Please enter valid amount"
                                );
                              }
                              const availbleAmount =
                                lender.sanctionedAmount - (total - value);
                              if (value > availbleAmount) {
                                return Promise.reject(
                                  `Please enter less amount than ${availbleAmount}`
                                );
                              }
                              return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        <InputNumber
                          onChange={(ev) =>
                            disbursedInputHandler(
                              ev,
                              lenderIndex,
                              "disbursedAmount",
                              index
                            )
                          }
                          disabled={payment?.lenderAmount?.isDisabled ?? false}
                          className="custom-input-number"
                          // defaultValue={payment?.lenderAmount?.disbursedAmount}
                          formatter={(value) => numberWithCommas(value)}
                          parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
                          name="disbursedAmount"
                          placeholder="Amount"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                )}
              </Form.List>
            </div>
            <Row className="selected-lender-row" gutter={[6, 6]}>
              <Col span={12} className="disbursed-row">
                <Form.Item
                  name="disbursalDate"
                  className="inline-label"
                  label="Disbursal Date"
                  style={{ marginLeft: "5px" }}
                  initialValue={
                    payment?.lenderAmount?.disbursalDate
                      ? moment(payment?.lenderAmount?.disbursalDate)
                      : ""
                  }
                  rules={[{ required: false }]}
                >
                  <DatePicker
                    onChange={(ev) => {
                      DatePickerInputHandler(
                        ev,
                        lenderIndex,
                        "disbursalDate",
                        index
                      );
                    }}
                    disabledDate={(current) =>
                      current.isAfter(moment().subtract(0, "day"))
                    }
                    style={{ width: "98%", marginLeft: "3px" }}
                    format={dateFormat}
                    className="custom-input"
                    placeholder="(YYYY-MM-DD)"
                  />
                </Form.Item>
              </Col>
              {leadData?.sourceOfCase === "CONNECTOR" && (
                <Col span={11} className="disbursed-row">
                  <Form.Item
                    name="payoutPercentage"
                    className="inline-label"
                    label="Connector Payout %"
                    initialValue={payment?.lenderAmount?.payoutPercentage}
                    rules={[
                      {
                        required: true,
                        message: "Please enter payout%",
                      },
                      {
                        pattern: DOUBLE_REGEX,
                        message: "Please enter valid payout%",
                      },
                      () => ({
                        validator(_, value) {
                          if (!value && value != 0) {
                            return Promise.reject();
                          }
                          if (isNaN(value)) {
                            return Promise.reject(
                              "Please enter valid payout %"
                            );
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <InputNumber
                      value={payment?.lenderAmount?.payoutPercentage}
                      // disabled={payment?.lenderAmount?.isDisabled ?? false}
                      onChange={(ev: any) => {
                        payoutPercentageInputHandler(
                          ev,
                          "payoutPercentage",
                          index
                        );
                      }}
                      className="custom-input-number"
                    />
                  </Form.Item>
                </Col>
              )}
            </Row>
            <br />
            <Col span={24}>
              <Form.Item
                name="comment"
                initialValue={payment?.lenderAmount?.comments ?? ""}
                rules={[{ required: false, message: "Please enter comment" }]}
              >
                <TextArea
                  name="comment"
                  showCount
                  maxLength={500}
                  className="custom-textarea"
                  placeholder="Comment"
                  onChange={(ev) =>
                    disbursedInputHandler(
                      ev.target.value,
                      lenderIndex,
                      "comments",
                      index
                    )
                  }
                />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Button
                type="primary"
                htmlType="submit"
                className="next-btn dynamic-btn-primary"
                style={btnPrimaryStyles}
                loading={loading}
              >
                Submit
              </Button>
            </Col>
          </Panel>
        </Collapse>
      </Form>
      <Modal
        width={350}
        visible={showConfirmationPayout}
        style={{ marginBottom: 230 }}
        okText="Yes"
        cancelText="No"
        title=""
        centered
        closable={false}
        maskClosable={false}
        footer={false}
      >
        <div style={{ padding: "15px" }}>
          <p style={{ fontSize: "17px" }}>
            This is a fixed payout connector. Are you sure you want to edit the
            payout% ?
          </p>
          <Space style={{ display: "flex", justifyContent: "center" }}>
            <Button
              type="primary"
              style={{ width: "85px", height: "35px" }}
              onClick={() => {
                confirmationSubmit();
              }}
            >
              OK
            </Button>
            <Button
              style={{ width: "85px", height: "35px" }}
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </Space>
        </div>
      </Modal>
    </div>
  );
};

export default DisbursedGroup;
